import { createGenerateClassName } from '@mui/styles';

// @material-ui/core (v4) and @mui/styles (the v5 bridge) each number their generated classes with
// their own counter, so without a prefix both emit `makeStyles-root-1` (`jss1` in production) and
// one engine's rules land on the other's elements. The seed keeps the bridge's classes apart; v4
// keeps its names because existing styles target them (`& .MuiButton-root`, `.jss…` never).
export const generateClassNameV5 = createGenerateClassName({ seed: 'v5' });
